import { META } from './data';
export default function Footer({ setPage }) {
  return (
    <footer className="bg-[#1B1A18] text-[#F2EBE0]">
      <div className="max-w-[1500px] mx-auto px-8 lg:px-14 py-14 grid md:grid-cols-[1.4fr_1fr_1fr_1fr] gap-10">
        <div>
          <p className="font-serif italic text-3xl">{META.brand}</p>
          <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#6F7E62] mt-2">{META.tagline}</p>
          <p className="text-sm text-[#F2EBE0]/60 mt-5 leading-[1.7] max-w-md">A small skincare house, est. {META.est}, formulating in batches of two hundred at our atelier in the field. Available only by appointment, online, or at the maison.</p>
        </div>
        <div>
          <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#B8654A] mb-3">Atelier</p>
          <p className="text-sm text-[#F2EBE0]/85 leading-relaxed">Les Lauves, Route de Cézanne<br />13100 Aix-en-Provence</p>
        </div>
        <div>
          <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#B8654A] mb-3">Boutique · Paris</p>
          <p className="text-sm text-[#F2EBE0]/85 leading-relaxed">14 rue de Tournon<br />75006 Paris</p>
        </div>
        <div>
          <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#B8654A] mb-3">Concierge</p>
          <p className="text-sm text-[#F2EBE0]/85 leading-relaxed">+33 4 42 555 0184<br /><span className="text-[#B8654A]">concierge@solene.fr</span></p>
        </div>
      </div>
      <div className="border-t border-[#F2EBE0]/15 px-8 lg:px-14 py-5 max-w-[1500px] mx-auto flex flex-wrap items-center justify-between gap-4 font-mono text-[10px] tracking-[0.3em] uppercase text-[#F2EBE0]/40">
        <span>© 2026 Solène, Maison de soins · Ecocert · Made in Provence</span>
        <div className="flex gap-6">
          <button onClick={() => setPage('atelier')} className="hover:text-[#B8654A]">L'Atelier</button>
          <a href="#" className="hover:text-[#B8654A]">Sustainability</a>
          <a href="#" className="hover:text-[#B8654A]">Privacy</a>
        </div>
      </div>
    </footer>
  );
}
